import api from "../../api";

export const createTarget = async (data) => {
  // console.log("data yo send",data);

  // try {
  //   const res = await api.post("/target/create", data);
  //   return res.data;
  // } catch (error) {
  //   throw error?.response?.data || { message: error.message };
  // }

  try {
    // Check if data contains a file in private_key
    if (data.assetListFile && data.assetListFile instanceof File) {
      // Create FormData for file upload
      const formData = new FormData();

      // Add all other data properties to formData
      Object.keys(data).forEach((key) => {
        if (key === "assetListFile") {
          formData.append("assetListFile", data.assetListFile);
        } else {
          formData.append(key, data[key]);
        }
      });

      // Send request with formData and appropriate headers
      const res = await api.post("/target/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return res.data;
    } else {
      // Regular JSON request if no file is present
      const res = await api.post("/target/create", data);
      return res.data;
    }
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const updateTarget = async (id, data) => {
  // console.log("data yo send",data);

  // try {
  //   const res = await api.post("/target/create", data);
  //   return res.data;
  // } catch (error) {
  //   throw error?.response?.data || { message: error.message };
  // }

  try {
    // Check if data contains a file in private_key
    if (data?.assetListFile && data?.assetListFile instanceof File) {
      // Create FormData for file upload
      const formData = new FormData();

      // Add all other data properties to formData
      Object.keys(data).forEach((key) => {
        if (key === "assetListFile") {
          formData.append("assetListFile", data.assetListFile);
        } else {
          formData.append(key, data[key]);
        }
      });

      // Send request with formData and appropriate headers
      const res = await api.post(`/target/update/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return res.data;
    } else {
      // Regular JSON request if no file is present
      const res = await api.post(`/target/update/${id}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return res.data;
    }
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const createScan = async (data) => {
  try {
    const res = await api.post("/scan/create", data);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const uploadInventory = async (payload) => {
  try {
    let res;

    if (payload instanceof File) {
      // CSV upload
      const formData = new FormData();
      formData.append("file", payload); // must match backend field name

      res = await api.post("/inventory/upload-csv", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    } else if (typeof payload === "object") {
      // JSON upload
      res = await api.post("/inventory/upload-csv", payload, {
        headers: { "Content-Type": "application/json" },
      });
    } else {
      throw new Error("Unsupported payload type. Must be File or JSON object.");
    }

    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};


